document.addEventListener('DOMContentLoaded', () => {

  // -------------------------------------------------------
  // 1. Level 2 panel switching (left tabs → right content)
  // -------------------------------------------------------
  const megaMenus = document.querySelectorAll('.mega-menu');

  megaMenus.forEach((menu) => {
    const items  = menu.querySelectorAll('.mega-level2-item');
    const panels = menu.querySelectorAll('.mega-level2-content');

    items.forEach((item) => {
      item.addEventListener('click', () => {
        const target = item.getAttribute('data-target');

        items.forEach((i) => {
          i.classList.remove('is-active');
          i.setAttribute('aria-expanded', 'false');
        });
        panels.forEach((p) => p.classList.remove('is-active'));

        item.classList.add('is-active');
        item.setAttribute('aria-expanded', 'true');
        const targetPanel = menu.querySelector('#' + target);
        if (targetPanel) {
          targetPanel.classList.add('is-active');
        }
      });
    });
  });

  // -------------------------------------------------------
  // 2. Smooth open / close for the main mega menu dropdowns
  //
  //    • Opening  → handled purely by CSS (@starting-style
  //      + transition on details[open] .custom-megamenu).
  //    • Closing  → we intercept the summary click, add the
  //      .is-closing class, wait for the CSS transition to
  //      finish, then actually close the <details> element.
  // -------------------------------------------------------
  const allDetails = document.querySelectorAll('details.mega-menu');

  allDetails.forEach((details) => {
    const content = details.querySelector('.mega-menu__content.custom-megamenu');
    const summary = details.querySelector('summary');
    if (!content || !summary) return;

    summary.addEventListener('click', (e) => {
      // Switching to a new menu → close the open one instantly, no animation
      if (!details.open) {
        allDetails.forEach((other) => {
          if (other === details || !other.open) return;
          const otherContent = other.querySelector('.mega-menu__content.custom-megamenu');
          if (otherContent) otherContent.classList.remove('is-closing');
          other.removeAttribute('open');
        });
        return; // let the browser open this details normally (CSS animation plays)
      }

      e.preventDefault();
      e.stopPropagation();

      // Kick off the exit animation
      content.classList.add('is-closing');

      // After the CSS transition finishes, actually close the details
      content.addEventListener(
        'transitionend',
        () => {
          content.classList.remove('is-closing');
          details.removeAttribute('open');
        },
        { once: true }
      );
    });
  });

  // -------------------------------------------------------
  // 3. Drawer accordions — only one open at a time
  //
  //    Applies to the mobile drawer's level 1 and level 3
  //    <details> accordions. Opening one collapses its
  //    siblings within the same <ul>, so accordions in
  //    separate level 2 panels never interfere.
  //
  //    Note: the 'toggle' event does not bubble, so this is
  //    registered in the capture phase. A normal delegated
  //    listener would never fire.
  // -------------------------------------------------------
  const ACCORDION_SELECTOR = '.drawer-accordion-l1, .drawer-accordion-l3';

  document.addEventListener(
    'toggle',
    (e) => {
      const details = e.target;

      if (!details.matches || !details.matches(ACCORDION_SELECTOR)) return;
      if (!details.open) return;

      const li = details.parentElement;      // the <li> wrapping this accordion
      const scope = li && li.parentElement;  // the <ul> holding the siblings
      if (!scope) return;

      Array.from(scope.children).forEach((sibling) => {
        if (sibling === li) return;
        const other = sibling.firstElementChild;
        if (other && other.matches(ACCORDION_SELECTOR) && other.open) {
          other.open = false;
        }
      });
    },
    true
  );

});